import React from "react";
import { useStore } from "../../store";
import type { LayoutType } from "../../store/slices/uiSlice";
import { IconButton } from "./IconButton";

const OPTIONS: { id: LayoutType; label: string }[] = [
  { id: "2-1", label: "2 1" },
  { id: "1-2", label: "1 2" },
  { id: "1-1", label: "1 1" },
  { id: "2-2", label: "2 2" },
  { id: "1", label: "1" },
];

export const LayoutSelector: React.FC = () => {
  const {
    leftLayout,
    rightLayout,
    setLeftLayout,
    setRightLayout,
    closeLayoutSelector,
  } = useStore();

  const renderOption = (
    side: "left" | "right",
    selected: LayoutType,
    onChange: (v: LayoutType) => void
  ) => (
    <div
      className={`flex flex-col space-y-3 p-4 flex-1 ${
        side === "right" ? "items-start" : "items-end"
      }`}
    >
      {OPTIONS.map((opt) => (
        <label
          key={`${side}-${opt.id}`}
          className={`flex items-center space-x-4 p-3 rounded-md cursor-pointer ${
            selected === opt.id ? "border-2 border-crane-selection-blue" : ""
          } `}
        >
          {side === "left" && (
            <span className="relative inline-flex items-center justify-center w-5 h-5">
              <input
                type="radio"
                name={`${side}-layout`}
                className="sr-only"
                checked={selected === opt.id}
                onChange={() => onChange(opt.id)}
              />
              <span
                className={`w-4 h-4 rounded-full border-2 flex items-center justify-center ${
                  selected === opt.id
                    ? "border-crane-selection-green"
                    : "border-crane-selection-green"
                }`}
              >
                {selected === opt.id && (
                  <span className="w-2 h-2 rounded-full bg-crane-selection-green" />
                )}
              </span>
            </span>
          )}
          {/* Placeholder preview */}
          <img
            src={`/assets/layout-${opt.id}.svg`}
            alt={opt.label}
            className={`w-24 ${
              selected === opt.id ? "opacity-100" : "opacity-50"
            }`}
          />
          {side === "right" && (
            <span className="relative inline-flex items-center justify-center w-5 h-5">
              <input
                type="radio"
                name={`${side}-layout`}
                className="sr-only"
                checked={selected === opt.id}
                onChange={() => onChange(opt.id)}
              />
              <span
                className={`w-4 h-4 rounded-full border-2 flex items-center justify-center ${
                  selected === opt.id
                    ? "border-crane-selection-green"
                    : "border-crane-selection-green"
                }`}
              >
                {selected === opt.id && (
                  <span className="w-2 h-2 rounded-full bg-crane-selection-green" />
                )}
              </span>
            </span>
          )}
        </label>
      ))}
    </div>
  );

  return (
    <div className="w-full h-full flex flex-col relative">
      <div className="flex items-center justify-between px-4 py-3 ">
        <div className="flex gap-2 justify-start items-center">
          <img src="/assets/icon-layout.png" alt="Layout" className="w-6 h-6" />
          <div className="text-lg font-medium">Select layout</div>
        </div>
        <IconButton
          src="/assets/icon-close.png"
          alt="Close"
          className="absolute right-0 top-0"
          onClick={closeLayoutSelector}
        />
      </div>

      <div className="flex-1 grid grid-cols-2 gap-0">
        <div className="border-r border-crane-darker">
          {renderOption("left", leftLayout, setLeftLayout)}
        </div>
        <div>{renderOption("right", rightLayout, setRightLayout)}</div>
      </div>
    </div>
  );
};
